
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ isAuthenticated, logout }) => {
  const navigate = useNavigate();
  const publicMenus = [
    { name: 'Login', path: '/login' },
    { name: 'Promotion', path: '/promotion' },
    { name: 'Events', path: '/events' },
    { name: 'Courses', path: '/courses' },
    { name: 'Fees', path: '/fees' },
    { name: 'Trainers', path: '/trainers' },
    { name: 'About Us', path: '/about-us' },
    { name: 'Contact Us', path: '/contact-us' },
    { name: 'Testimonials', path: '/testimonials' },
  ];

  const privateMenus = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'Member Registration', path: '/member-registration' },
    { name: 'Attendance Management', path: '/attendance-management' },
    { name: 'Reports', path: '/reports' },
    { name: 'Notifications', path: '/notifications' },
    { name: 'Trainer Management', path: '/trainer-management' },
    { name: 'Batch Management', path: '/batch-management' },
    { name: 'Payments', path: '/payments' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="w-64 min-w-64 max-w-64 flex-shrink-0 bg-gray-800 text-white p-4 flex flex-col rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-6 text-center text-purple-300">Menu</h2>
      <ul className="space-y-3">
        {isAuthenticated ? (
          <>
            {privateMenus.map((menu) => (
              <li key={menu.path}>
                <button
                  onClick={() => navigate(menu.path)}
                  className="w-full text-left py-2 px-4 rounded-md hover:bg-purple-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  {menu.name}
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={handleLogout}
                className="w-full text-left py-2 px-4 rounded-md bg-red-600 hover:bg-red-700 transition-colors duration-200 mt-4 focus:outline-none focus:ring-2 focus:ring-red-500"
              >
                Logout
              </button>
            </li>
          </>
        ) : (
          publicMenus.map((menu) => (
            <li key={menu.path}>
              <button
                onClick={() => navigate(menu.path)}
                className="w-full text-left py-2 px-4 rounded-md hover:bg-indigo-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                {menu.name}
              </button>
            </li>
          ))
        )}
      </ul>
    </nav>
  );
};

export default Sidebar;
